import React, { useContext, useEffect, useState } from 'react'
import BigModal from '../../../../components/Modals/BigModal'
import {
  Box,
  Typography,
  Button,
  TextField,
  FormControlLabel,
  Checkbox,
  RadioGroup,
  Radio,
  Divider,
  Stack,
  Alert,
} from '@mui/material'
import API from '../../../../services/API'
import { useNavigate } from 'react-router-dom'
import { GlobalContext } from '../../../../App'
import StaffSelector from '../../../events/StaffSelector'
import WarningAmberIcon from '@mui/icons-material/WarningAmber'
import EmployeeSelector from '../../../events/EmployeeSelector'

const ReassignRecord = ({
  open,
  onClose,
  loadRecord,
  recordID,
  setMenuAnchorEl,
}) => {
  const [staff, setStaff] = useState(null)
  const [reason, setReason] = useState('')
  const { setToast } = useContext(GlobalContext)

  useEffect(() => {
    setStaff(null)
    setReason('')
  }, [open])

  const handleTransfer = () => {
    if (!staff || !reason.trim()) return

    API.post('/epcr/transferownership-manager', {
      epcrID: recordID,
      reason,
      newEmployee: staff._id,
    }).then((res) => {
      if (res.status === 200) {
        loadRecord()
        onClose()
        setToast({ message: 'Record Transferred' })
        setMenuAnchorEl(null)
      } else {
        setToast({
          message: 'Unable to transfer record',
          severity: 'error',
        })
      }
    })
  }

  return (
    <BigModal open={open} onClose={onClose} style={{ border: 'solid 2px red' }}>
      <Box display="flex" flexDirection="column" gap={3} padding={2}>
        <Typography variant="title2">
          Reassign Electronic Patient Care Record
        </Typography>

        <EmployeeSelector
          value={staff}
          onChange={(e, value) => setStaff(value)}
          label="Employee"
        />

        <TextField
          label="Reason for transferring"
          placeholder="e.g., Entered in error"
          multiline
          fullWidth
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          required
        />

        <Divider />

        <Stack gap={1}>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            🔁 <strong>Transfer Notice</strong>
            <br />
            Under the{' '}
            <strong>UK General Data Protection Regulation (UK GDPR)</strong> and
            guidance from the <strong>Care Quality Commission (CQC)</strong>,
            all actions taken on patient records must be lawful, appropriate,
            and fully auditable.
          </Typography>

          <Typography variant="body2" color="text.secondary">
            You are about to transfer this electronic patient care record (ePCR)
            to a different staff member.
          </Typography>

          <Stack>
            <Alert severity="error">
              Clinical responsibility for the record will be reassigned
            </Alert>
            <Alert severity="error">
              The record will be placed back into <strong>draft status</strong>
            </Alert>
            <Alert severity="error">
              A snapshot of the record at the time of transfer will be saved for
              audit
            </Alert>
            <Alert severity="error">
              A log of this action will be recorded, including your reason
            </Alert>
          </Stack>
        </Stack>

        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          This action does <strong>not delete or alter</strong> the contents of
          the record. Transfers must be clinically justified and carried out in
          accordance with your organisation’s information governance policies.
        </Typography>

        <Box display="flex" justifyContent="flex-end" gap={2}>
          <Button onClick={onClose}>Cancel</Button>
          <Button
            variant="contained"
            color="success"
            disabled={!staff || !reason.trim()}
            onClick={handleTransfer}
          >
            Transfer
          </Button>
        </Box>
      </Box>
    </BigModal>
  )
}

export default ReassignRecord
